import { render, staticRenderFns } from "./QuestionResolved.vue?vue&type=template&id=3186af2a&scoped=true"
import script from "./QuestionResolved.vue?vue&type=script&lang=js"
export * from "./QuestionResolved.vue?vue&type=script&lang=js"
import style0 from "./QuestionResolved.vue?vue&type=style&index=0&id=3186af2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3186af2a",
  null
  
)

export default component.exports